import React from 'react';
import { observer } from 'mobx-react-lite';
import { useFormikContext } from 'formik';
import { Prompt } from 'react-router-dom';

import { fixedFormikSubmit } from 'src/helpers';
import { useStateCallback } from 'src/hooks';
import { useStore } from '@src/models';
import { ConfirmationModal } from '../ConfirmationModal';

export const FormikRouteTransitionConfirmation = observer(function FormikRouteTransitionConfirmation() {
  const { routerStore } = useStore();
  const { dirty, submitForm, validateForm } = useFormikContext();

  const [showConfirmationModal, setShowConfirmationModal] = React.useState(false);
  const [nextLocation, setNextLocation] = React.useState(null);
  const [blockRouteTransition, setBlockRouteTransition] = useStateCallback(dirty);

  React.useEffect(() => {
    setBlockRouteTransition(dirty);
  }, [setBlockRouteTransition, dirty]);

  const handleRouteTransition = React.useCallback(
    location => {
      if (dirty) {
        setNextLocation(location);
        setShowConfirmationModal(true);
        return false;
      }
      return true;
    },
    [dirty]
  );

  const closeConfirmationModal = React.useCallback(() => setShowConfirmationModal(false), []);

  const handleConfirm = async () => {
    closeConfirmationModal();
    try {
      await fixedFormikSubmit({ submitForm, validateForm });
      routerStore.push(nextLocation.pathname);
    } catch (e) {}
  };

  return (
    <>
      {showConfirmationModal && (
        <ConfirmationModal
          title="Do you want to save your changes?"
          onClose={closeConfirmationModal}
          onCancel={() => {
            setBlockRouteTransition(false, () => {
              routerStore.push(nextLocation.pathname);
            });
          }}
          onConfirm={handleConfirm}
        />
      )}
      <Prompt when={blockRouteTransition} message={handleRouteTransition} />
    </>
  );
});
